"use client"

import {
    CircularProgress,
    IconButton,
    Typography
} from "@mui/material"
import React, { useEffect, useState } from "react"
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom"

import VisibilityIcon from "@mui/icons-material/Visibility"
import Box from "@mui/material/Box"
import { AuthContext } from "context"
import "dayjs/locale/it"
import { createMRTColumnHelper } from "material-react-table"
import MDButton from "../../components/MDButton"
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar"
import apiService from "../../services/api-service"
import GenericTable from "../genericTable"

const SteelWithdrawalRegistrationManagment = () => {
  const navigate = useNavigate()
  const authContext = React.useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [documents, setDocuments] = useState([])
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedDocumentId, setSelectedDocumentId] = useState(null)

  const columnHelper = createMRTColumnHelper()

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'steel-withdrawal-registration-managment-toast'});
    } else {
      toast.error(msg, {id: 'steel-withdrawal-registration-managment-toast'});
    }
  }

  useEffect(() => {
    fetchDocument()
  }, [])

  const fetchDocument = async () => {
    setLoading(true)
    apiService
      .get(
        "/steel-withdrawal-registration-managment/",
        { id_area: localStorage.getItem("areaSelected") },
        {},
      )
      .then((response) => {
        if (response) setDocuments(response)
      })
      .catch((error) => {
        handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onEdit = (id) => {
    window.location.href = "/steel-withdrawal-registration-managment/edit/" + id + "/"
  }


  const columns = [
    columnHelper.accessor("date", {
      header: "Prelevato il",
      size: 80,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor("processing_name", {
      header: "Nome processo",
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor("samples", {
      header: "Numero Campioni",
      size: 50,
      enableSorting: true,
      enableColumnFilterModes: true,
      Cell: ({ cell }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "space-between",
            padding: 1.5,
            borderRadius: 2,
            width: "50%",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500, color: "text.primary" }}>
            {cell.getValue()}
          </Typography>
          <IconButton
            onClick={() => navigate(`/steel-samples/selected/${cell.row.original.id}/`)}
            aria-label="View details"
            sx={{
              color: "black",
              transition: "color 0.2s ease-in-out",
              "&:hover": { color: "#0c40c6" },
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </Box>
      ),
    }),
    columnHelper.accessor("steel_type", {
      header: "Tipo acciaio",
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor("report_number", {
      header: "Numero report",
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor("dl_name", {
      header: "Nome DL",
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
  ]

  async function deleteResource(id, endpoint) {
    try {

      // Parametri opzionali per la richiesta DELETE
      const params = { id: id } // Puoi aggiungere parametri se necessario
      const headers = {} // Headers opzionali

      // Esegui la chiamata DELETE
      const response = await apiService.delete(endpoint, params, headers)

      // Se arriviamo qui, la chiamata è andata a buon fine
      console.log(`Risorsa con id ${id} eliminata con successo:`, response)

      // Puoi fare qualcosa con la risposta, se necessario
      return response
    } catch (error) {
      // Gestisci eventuali errori
      console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message)

      // Puoi gestire l'errore in modo specifico, ad esempio:
      if (error.message.includes("404")) {
        console.log(`La risorsa con id ${id} non è stata trovata`)
      } else if (error.message.includes("403")) {
        console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`)
      }

      // Rilancia l'errore se vuoi che venga gestito a un livello superiore
      throw error
    }
  }

  function handleDelete(id) {
    if (window.confirm("Sei sicuro di voler eliminare questo prelievo?\n Attenzione questa operazione è irreversibile.")) {
      deleteResource(id,'/steel-withdrawal-registration-managment/')
        .then((result) => {
          handleSetNotification("prelievo eliminato con successo", "success")
          fetchDocument()
        })
        .catch((error) => {
          // Gestisci l'errore se non è stato gestito nella funzione
          handleSetNotification(
            "Si è verificato un errore durante l'eliminazione del prelievo. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032",
            "error",
          )
        })
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!loading ? (
        <>
          <center>
            <Typography variant="h4" sx={{ marginTop: "20px" }}>
              ELENCO PRELIEVI
            </Typography>
            {authContext.hasAuth("UPDATE_STEELWITHDRAWALREGISTRATION") && (
              <MDButton
                onClick={() => navigate("/steel-withdrawal-registration-managment/add/")}
                size="large"
                sx={{ marginTop: "20px", marginBottom: "20px" }}
              >
                {" "}
                AGGIUNGI
              </MDButton>
            )}
            <GenericTable
              data={documents}
              columns={columns}
              onEdit={onEdit}
              onDelete={handleDelete}
              authModelName="STEELWITHDRAWALREGISTRATION"
            />
          </center>
        </>
      ) : (
        <center>
          <CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
        </center>
      )}
    </DashboardLayout>
  )
}

export default SteelWithdrawalRegistrationManagment
